export async function processGridInventory() {
  try {
    var gridProducts = document.querySelectorAll(".grid-product:not([data-inventory-processed]");
    var cartProducts = document.querySelectorAll(".cart__item:not([data-inventory-processed]");

    if(!gridProducts && !cartProducts) {
      return;
    }
    var productGids = [];
    for (let i = 0; i < gridProducts.length; i++) {
      const product = gridProducts[i];
      const productId = product.dataset.productId;
      const productGid = "gid://shopify/Product/" + productId;
      productGids.push(productGid);
      product.setAttribute('data-inventory-processed', 'true');
    }

    for (let i = 0; i < cartProducts.length; i++) {
      const product = cartProducts[i];
      const productId = product.dataset.productId;
      const productGid = "gid://shopify/Product/" + productId;
      productGids.push(productGid);
      product.setAttribute('data-inventory-processed', 'true');
    }

    const productByIdQuery = 
    `query GetProductNodes {
        nodes(ids: ${JSON.stringify(productGids)}) {
        ... on Product {
          id
          title
          tags
          variants(first: 2) {
            edges {
              node {
                id
                storeAvailability(first: 3) {
                  edges{
                    node{
                      location {
                        id
                        name
                      }
                      quantityAvailable
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`;
  
    const options = {
      method: "POST",
      headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'c5767ea43a1925690628bfa255776537'
      },
      body: JSON.stringify({
        query: productByIdQuery
      })
    };
  
    const graphqlResponse = await fetch(`https://thatchers-wine-consulting.myshopify.com/api/2024-04/graphql.json`, options);
    
    const data = await graphqlResponse.json();
  
    data.data.nodes.forEach((node) => {
      if(node){
        const productId = node.id;
        const idNumber = productId.slice(22);
        const quantityElements = document.querySelectorAll(`[data-quantity-product-id="${idNumber}"]`);

        const productElements = document.querySelectorAll(`[data-product-id="${idNumber}"]`);

        const storeAvailabilities = node.variants.edges[0].node.storeAvailability.edges;
    
        var warehouseStock;
        var losAngelesStock;
      
        storeAvailabilities.forEach((availabilityNode) => {
          const locationId = availabilityNode.node.location.id;
          const locationInventory = availabilityNode.node.quantityAvailable;
    
          if(locationId == "gid://shopify/Location/36100145291") {
            warehouseStock = locationInventory;
          }
    
          else if (locationId == "gid://shopify/Location/68095541411"){
            losAngelesStock = locationInventory;
          }
    
        });

        var maxQuantity;
        var maxLocation;

        if(!losAngelesStock || warehouseStock >= losAngelesStock){
          maxQuantity = warehouseStock;
          maxLocation = "warehouse";
        }

        else {
          maxQuantity = losAngelesStock;
          maxLocation = "la";
        }

        if(maxQuantity != null){
          if(productElements){
            productElements.forEach((productElement) => {
              productElement.setAttribute('data-mq', maxQuantity);
            });
          }
        }
        
        if(warehouseStock > 12) {
          warehouseStock = "12+";
        }
    
        if(losAngelesStock > 12) {
          losAngelesStock = "12+";
        }
    
        const productTags = node.tags;
      
        var limitValue = 0;
        var isPrearrival = false;
        var size = '';
        productTags.forEach(tag => {
          if (tag.includes('limit')) {
            if (tag.includes('limit_one')) {
              limitValue = 1;
            } else if (tag.includes('limit_two')) {
              limitValue = 2;
            } else if (tag.includes('limit_three')) {
              limitValue = 3;
            } else if (tag.includes('limit_four')) {
              limitValue = 4;
            } else if (tag.includes('limit_five')) {
              limitValue = 5;
            } else if (tag.includes('limit_six')) {
              limitValue = 6;
            } else if (tag.includes('limit_seven')) {
              limitValue = 7;
            } else if (tag.includes('limit_eight')) {
              limitValue = 8;
            } else if (tag.includes('limit_nine')) {
              limitValue = 9;
            } else if (tag.includes('limit_ten')) {
              limitValue = 10;
            } else if (tag.includes('limit_eleven')) {
              limitValue = 11;
            } else if (tag.includes('limit_twelve')) {
              limitValue = 12;
            }
          } 
          
          else if(tag.includes('prearrival_')){
            isPrearrival = true;
          }
    
          else if(tag.includes('size_')){
            size = tag.replace('size_','');
          } 
          
          else if(tag.includes('_size')){
            size = tag.replace('_size','');
          }
        });
    
        var textContent;
        var spanContent;
        
        if (limitValue > 0) {
          textContent = `${limitValue} – ${size} Limit`;
        }
        else if(isPrearrival) {
          textContent = warehouseStock + " Pre-Arrival";
        }
        else if(maxLocation == "warehouse" && warehouseStock && warehouseStock != 0){
          textContent = warehouseStock + " In Stock";
          spanContent = " Online";
        } 
        else if(maxLocation == "la" && losAngelesStock && losAngelesStock != 0){
          textContent = losAngelesStock + " In Stock";
          spanContent = " LA";
        }
        else {
          textContent = "0 In Stock";
        }

        if(quantityElements){
          quantityElements.forEach((element) => {
            element.textContent = textContent;
            if(spanContent){
              let span = document.createElement('span');
              span.classList.add("quantity-label");
              span.textContent = spanContent;
              element.appendChild(span);
            }
          });
        }

        if(textContent){
          document.querySelectorAll(`[data-liquid-inventory-product-id="${idNumber}"]`).forEach((e) => {
            e.style.display = 'none';
          });
        }
      }
    });
  } catch(error) {
    console.error(error);
  }
}


export async function processCartInventory () {
    try {
        var cartProducts = document.querySelectorAll(".stock-items:not([data-inventory-processed]");
        if(!cartProducts) {
          return;
        }
        var productGids = [];
        for (let i = 0; i < cartProducts.length; i++) {
          const product = cartProducts[i];
          const productId = product.dataset.productId;
          const productGid = "gid://shopify/Product/" + productId;
          productGids.push(productGid);
          product.setAttribute('data-inventory-processed', 'true');
        }
      
        const productByIdQuery = 
        `query GetProductNodes {
            nodes(ids: ${JSON.stringify(productGids)}) {
            ... on Product {
              id
              title
              tags
              variants(first: 2) {
                edges {
                  node {
                    id
                    storeAvailability(first: 3) {
                      edges{
                        node{
                          location {
                            id
                            name
                          }
                          quantityAvailable
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }`;
      
        const options = {
          method: "POST",
          headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'c5767ea43a1925690628bfa255776537'
          },
          body: JSON.stringify({
            query: productByIdQuery
          })
        };
      
        const graphqlResponse = await fetch(`https://thatchers-wine-consulting.myshopify.com/api/2024-04/graphql.json`, options);
        
        const data = await graphqlResponse.json();
      
        data.data.nodes.forEach((node) => {
          if(node){
            const productId = node.id;
            const idNumber = productId.slice(22);
            const quantityElements = document.querySelectorAll(`[data-quantity-product-id="${idNumber}"]`);
        
            const storeAvailabilities = node.variants.edges[0].node.storeAvailability.edges;
        
            var warehouseStock;
            var losAngelesStock;
        
            storeAvailabilities.forEach((availabilityNode) => {
              const locationId = availabilityNode.node.location.id;
              const locationInventory = availabilityNode.node.quantityAvailable;
        
              if(locationId == "gid://shopify/Location/36100145291") {
                warehouseStock = locationInventory;
              }
        
              else if (locationId == "gid://shopify/Location/68095541411"){
                losAngelesStock = locationInventory;
              }
        
            });

            var maxQuantity;
            if(!losAngelesStock || warehouseStock > losAngelesStock){
              maxQuantity = warehouseStock;
            }
    
            else {
              maxQuantity = losAngelesStock;
            }
    
            if(maxQuantity){
              if(productElements){
                productElements.forEach((productElement) => {
                  productElement.setAttribute('data-mq', maxQuantity);
                });
              }
            }
        
            if(warehouseStock > 12) {
              warehouseStock = "12+";
            }
        
            if(losAngelesStock > 12) {
              losAngelesStock = "12+";
            }
        
            const productTags = node.tags;
          
            var limitValue = 0;
            var isPrearrival = false;
            var size = '';
            productTags.forEach(tag => {
              if (tag.includes('limit')) {
                if (tag.includes('limit_one')) {
                  limitValue = 1;
                } else if (tag.includes('limit_two')) {
                  limitValue = 2;
                } else if (tag.includes('limit_three')) {
                  limitValue = 3;
                } else if (tag.includes('limit_four')) {
                  limitValue = 4;
                } else if (tag.includes('limit_five')) {
                  limitValue = 5;
                } else if (tag.includes('limit_six')) {
                  limitValue = 6;
                } else if (tag.includes('limit_seven')) {
                  limitValue = 7;
                } else if (tag.includes('limit_eight')) {
                  limitValue = 8;
                } else if (tag.includes('limit_nine')) {
                  limitValue = 9;
                } else if (tag.includes('limit_ten')) {
                  limitValue = 10;
                } else if (tag.includes('limit_eleven')) {
                  limitValue = 11;
                } else if (tag.includes('limit_twelve')) {
                  limitValue = 12;
                }
              } 
              
              else if(tag.includes('prearrival_')){
                isPrearrival = true;
              }
        
              else if(tag.includes('size_')){
                size = tag.replace('size_','');
              } 
              
              else if(tag.includes('_size')){
                size = tag.replace('_size','');
              }
            });
        
            var textContent;
            var spanContent;

            if(warehouseStock <= 0 && laStock <= 0) {
              textContent = "0 In Stock";
            }

            else if(isPrearrival && warehouseStock > 0){
              textContent = warehouseStock + " Pre-Arrival";
            }

            else if(warehouseStock >= laStock){
              textContent = warehouseStock + " In Stock";
              spanContent = " Online";
            } 
            
            else if(laStock > warehouseStock) {
              textContent = losAngelesStock + " In Stock";
              spanContent = " LA";
            }

            else {
              textContent = "0 In Stock";
            }
        
            if (limitValue > 0) {
              textContent = `${limitValue} – ${size} Limit`;
            }
            
            if(quantityElements){
              quantityElements.forEach((element) => {
                element.textContent = textContent;
                if(spanContent){
                  let span = document.createElement('span');
                  span.classList.add("quantity-label");
                  span.textContent = spanContent;
                  element.appendChild(span);
                }
              });
            }

            if(textContent){
              document.querySelectorAll(`[data-liquid-inventory-product-id="${idNumber}"]`).forEach((e) => {
                e.style.display = 'none';
              });
            }
          }
        });
      } catch(error) {
        console.error(error);
      }
}
